// ----------------------------------------------------------------------
// <copyright file="Izenda.PropertiesEditor.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx-react');
  var React = require('react');
  var classnames = require('classnames');

  var FormGroup = require('./Izenda.FormGroup');
  var InputByDataType = require('./Izenda.InputByDataType');
  var PropertiesEditorManager = require('modules/Izenda.PropertiesEditorManager');
  var { MAP_TYPES } = require('logic/data/Izenda.ReportPartMapConstants');
  const { CHART_SCHEMA_NAMES } = require('logic/data/Izenda.ReportPartChartConstants');
  const { FIELDS } = CHART_SCHEMA_NAMES;
  const { ContainerName } = require('logic/data/Izenda.ReportPartMapConstants');

  const {
    isNil,
    getOr,
    concat,
    has,
    clone,
    merge,
    reduce,
    isObject,
    assign,
    get,
    isFunction,
    tail,
    isString,
    isUndefined
  } = require('lodash/fp');
  var FieldItem = m.observer(function(props) {
    var fieldDef = props.itemDef || {};
    var fieldSource = props.itemSource || {};
    var fieldSourceProps = fieldSource.props || {};
    var fieldName = props.itemName;
    var hasTitle = !isNil(fieldDef.title);
    // To render the component into the FormGroup when the component is custom and doesn't has title
    var usingGroup = fieldDef.usingGroup;

    var labelClass = classnames(['control-label', 'prop-label'], fieldDef.titleClassName || '');
    var controlClass = classnames('prop-control', fieldDef.controlClassName || '', {
      u_fullWidth: !hasTitle
    });
    var titleHasMoreThanOneWord = fieldDef.title && fieldDef.title.indexOf(" ")>=0;
    var fieldClass = classnames('form-group', fieldDef.fieldClassName || '', {
      "middle-align": titleHasMoreThanOneWord });
    var disabled = get('values.disabled', fieldSourceProps);
    var disabledInfo = fieldDef.disabledInfo;
    var content = (
      <div className={controlClass}>
        {renderControl.bind(this)()}
        {disabled && disabledInfo && (
          <a className='icon-info'>
            <span className='icon-info-circled' title={disabledInfo} />
          </a>
        )}
      </div>
    );
    var tooltip = getOr('', 'values.title', fieldSourceProps);

    if (hasTitle || usingGroup) {
      return (
        <FormGroup className={fieldClass} key={fieldName}>
          {fieldDef.title && (
            <label className={labelClass} title={tooltip}>
              {fieldDef.title}
              {fieldDef.infoIcon && (
                <a className='icon-info'>
                  <span className='icon-info-circled' title={fieldDef.infoIcon} />
                </a>
              )}
            </label>
          )}
          {content}
        </FormGroup>
      );
    } else {
      return content;
    }

    /**
     * render control base on props component or props type
     * @return {React} React component coresponding to the config
     */
    function renderControl() {
      if (props.component) {
        return (
          <props.component
            closePopover={props.closePopover}
            {...props.uiProps}
            {...fieldDef.staticProps}
            {...fieldSourceProps.values}
            {...fieldSourceProps.fnProps}
            keyPath={props.keyPath}
            {...fieldSourceProps.promiseProps}
            value={fieldSource.value}
            onChange={onChange.bind(this)}
          />
        );
      } else {
        return (
          <InputByDataType
            {...props.uiProps}
            {...fieldDef.staticProps}
            {...fieldSourceProps.values}
            {...fieldSourceProps.fnProps}
            keyPath={props.keyPath}
            {...fieldSourceProps.promiseProps}
            type={fieldDef.type}
            value={fieldSource.value}
            onChange={onChange.bind(this)}
          />
        );
      }
    }

    /**
     * onChange function will call updateDataSchemaByKey in propertiesEditorModel
     * @param  {object} newValue update value for this component
     */
    function onChange(newValue) {
      var propertiesEditorModel = props.parentProps.propertiesEditorModel || {};

      propertiesEditorModel.updateDataSchemaByKey &&
        propertiesEditorModel.updateDataSchemaByKey.apply(
          propertiesEditorModel,
          concat([has('value', newValue) ? newValue.value : newValue, fieldName, props.keyPath], tail(arguments))
        );
    }
  });

  FieldItem.displayName = 'FieldItem';

  var GroupItem = m.observer(
    React.createClass({
      propTypes: {
        keyPath: React.PropTypes.array,
        itemName: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number])
      },

      componentWillMount: function() {
        this.keyPath = clone(this.props.keyPath || []);
        this.props.itemName && this.keyPath.push(this.props.itemName);
      },

      render: function() {
        var props = this.props;
        var groupName = props.itemName;
        var groupDef = props.itemDef;
        var groupSource = props.itemSource || {};

        if (isHiddenGroup()) {
          return null;
        }

        if (props.component) {
          // render group by user-defined-component
          return (
            <props.component
              key={groupName}
              closePopover={props.closePopover}
              {...groupDef.props}
              {...groupDef.staticProps}
              keyPath={this.keyPath}
              {...groupSource.props.values}
              {...groupSource.props.fnProps}
            >
              {renderContent.bind(this)()}
            </props.component>
          );
        } else {
          // render group as section group
          return (
            <section
              key={groupName}
              {...groupDef.props}
              {...groupDef.staticProps}
              {...groupSource.props.values}
              {...groupSource.props.fnProps}
            >
              {groupDef.title ? (
                <div className='title-group-container'>
                  <strong className='title-group'>{groupDef.title}</strong>
                </div>
              ) : null}
              {renderContent.bind(this)()}
            </section>
          );
        }

        /**
         * return list of react element
         * @return {React.element} [description]
         */
        function renderContent() {
          // render fields of group
          return Object.keys(groupDef.fields).map(
            function(fieldName) {
              return (
                <GeneralItem
                  key={fieldName}
                  closePopover={this.props.closePopover}
                  itemName={fieldName}
                  itemDef={groupDef.fields[fieldName]}
                  keyPath={this.keyPath}
                  parentProps={props.parentProps}
                  itemSource={groupSource[fieldName]}
                  uiProps={props.uiProps}
                />
              );
            }.bind(this)
          );
        }

        /**
         * Hide group if all its fields are hidden
         **/
        function isHiddenGroup() {
          var countHidden = 0;
          var fieldKeys = Object.keys(groupDef.fields);

          if (!fieldKeys.length) {
            return false;
          }

          countHidden = reduce(
            function(countHidden, fieldKey) {
              var hidden =
                groupSource[fieldKey] &&
                isHidden(fieldKey, groupDef.fields[fieldKey], props.parentProps.mappingSource, props.itemSource);
              return hidden ? countHidden + 1 : countHidden;
            },
            countHidden,
            fieldKeys
          );

          return countHidden === fieldKeys.length;
        }
      }
    })
  );

  /**
   * Check hidden of a component.
   * @param {String} itemName
   * @param {Object} itemDef
   * @param {Object} mappingSource
   * @param {Object} itemSource
   */
  function isHidden(itemName, itemDef, mappingSource, itemSource) {
    if (isUndefined(itemDef.isHidden)) {
      // default - item is shown
      return false;
    }
    if (isString(itemDef.isHidden)) {
      // read data from mappingSource
      var mappingValue = mappingSource[itemDef.isHidden];
      return isFunction(mappingValue) ? mappingSource[itemDef.isHidden](itemName, itemDef, itemSource) : !!mappingValue;
    }

    return !!itemDef.isHidden;
  }

  function getFnProps(itemName, itemDef, mappingSource, itemSource) {
    if (isUndefined(itemDef.fnProps)) {
      // default - item is enabled
      return false;
    }
    if (isString(itemDef.fnProps)) {
      // read data from mappingSource
      var mappingValue = mappingSource[itemDef.fnProps];
      return isFunction(mappingValue) ? mappingSource[itemDef.fnProps](itemName, itemDef, itemSource) : !!mappingValue;
    }

    return !!itemDef.fnProps;
  }

  var GeneralItem = m.observer(function(props) {
    var itemName = props.itemName;
    var itemDef = props.itemDef;
    var itemSource = props.itemSource;
    var mappingSource = props.parentProps.mappingSource;

    var keyPath = props.keyPath || [];

    var propetyPanelStyle = PropertiesEditorManager.getViewStyle();
    var hiddenByState = get('props.values.hiddenByState', itemSource);

    if (
      itemSource &&
      (isHidden(itemName, itemDef, mappingSource, itemSource) || (!!hiddenByState && propetyPanelStyle.simpleState))
    ) {
      return null;
    }

    // Apply dynamic properties from schema
    if (!isUndefined(itemDef.fnProps)) {
      const dynamicProps = itemSource && getFnProps(itemName, itemDef, mappingSource, itemSource);
      itemDef.staticProps = merge(itemDef.staticProps || {}, dynamicProps);
    }

    const itemComponent = {
      name: itemDef.fields ? GroupItem : FieldItem
    };
    return (
      <itemComponent.name
        itemName={itemName}
        closePopover={this.props.closePopover}
        itemDef={itemDef}
        keyPath={keyPath}
        itemSource={itemSource}
        component={itemDef.component && getComponent(itemDef.component)}
        parentProps={props.parentProps}
        uiProps={props.uiProps}
      />
    );

    /**
     * get component from widgets list
     * @param  {string} comonentName name of component in widgets colection
     * @return {React.element|string}              react element from widgets collection
     */
    function getComponent(comonentName) {
      return (props.parentProps.widgets && props.parentProps.widgets[comonentName]) || comonentName;
    }
  });
  GeneralItem.displayName = 'GeneralItem';

  var PropertiesEditor = React.createClass({
    propTypes: {
      definedSchema: React.PropTypes.object.isRequired,
      schemaData: React.PropTypes.object,
      propertiesEditorModel: React.PropTypes.object
    },

    componentWillMount: function(nextProps) {
      this.updateSchemaData(this.props.schemaData);
    },

    componentWillReceiveProps: function(nextProps) {
      var props = this.props;
      var propertiesEditorModel = props.propertiesEditorModel || {};

      if (nextProps.definedSchema.schemaKey !== props.definedSchema.schemaKey) {
        this.updateSchemaData(nextProps.schemaData);
      } else {
        propertiesEditorModel.updateSchemaData &&
          propertiesEditorModel.updateSchemaData(this.schemaData, nextProps.schemaData);
      }
    },

    updateSchemaData: function(schemaData) {
      var propertiesEditorModel = this.props.propertiesEditorModel || {};
      this.schemaData = propertiesEditorModel.observerObject && propertiesEditorModel.observerObject(schemaData);
      propertiesEditorModel.setDataSchema && propertiesEditorModel.setDataSchema(this.schemaData);
    },

    renderItem: function(itemName, itemDef, itemSource) {
      return (
        <GeneralItem
          key={itemName}
          itemName={itemName}
          itemDef={itemDef}
          itemSource={itemSource}
          parentProps={assign(this.props, { updateSchema: this.updateSchema })}
          uiProps={this.props.uiProps}
          closePopover={this.props.closePopover}
        />
      );
    },

    render: function() {
      var definedSchema = this.props.definedSchema;

      if (!definedSchema) {
        return null;
      }

      definedSchema = isObject(definedSchema) ? [definedSchema] : definedSchema;
      var classes = classnames(this.props.className, 'izenda-PropertiesEditor');

      return (
        <section className={classes} aria-expanded='false'>
          {definedSchema.map(
            function(item, index) {
              return this.renderItem(index, item, this.schemaData);
            }.bind(this)
          )}
        </section>
      );
    }
  });

  module.exports = m.observer(PropertiesEditor);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.PropertiesEditor.jsx